<template>
  <div class="lex-on-app">
    <MainLayout />
  </div>
</template>
<script lang="ts" setup>
import MainLayout from '@/components/layouts/MainLayout.vue'
</script>
<style lang="scss">
@import '~@syncfusion/ej2-base/styles/material.css';
@import '~@syncfusion/ej2-buttons/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-navigations/styles/material.css';
@import '~@syncfusion/ej2-popups/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-vue-grids/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-lists/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import '~@syncfusion/ej2-pivotview/styles/material.css';

html.overflow-y-hidden {
  overflow-y: auto !important;
}

.lex-on-app .theme--light.v-application,
body {
  background-color: $neutral-white-000;
  font-family: $secondary-font;
  color: $gray-01;
  width: 100vw;
}

.v-main {
  min-height: calc(100vh - 120px);

  &.is-mobile {
    min-height: 100vh;
  }
}

.app-container {
  display: flex;
  height: 100%;
}

.v-application--wrap {
  z-index: 201;
  min-height: 100%;
}

.popover {
  z-index: 9999;
}

/* Change Autocomplete styles in Chrome*/
input:-webkit-autofill,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: $neutral-grey-800;
  box-shadow: 0 0 1px 1000px $white-01 inset;
  -webkit-box-shadow: 0 0 1px 1000px $white-01 inset;
  transition: none;
}

input:-webkit-autofill:hover {
  box-shadow: 0 0 1px 1000px $white-01 inset;
}

.stage-selector-input {
  .v-input__append-inner {
    margin-top: 4px;
  }

  .v-menu__content.menuable__content__active.v-autocomplete__content {
    top: 40px !important;
  }
}

.lexon-view-container {
  width: 100%;
  padding: 43px 30px 15px;
}

.spinner-layer-component {
  --spinner-layer-min-height: 100vh;
  --spinner-layer-position: absolute;
}

.alerts-container {
  margin-top: 65px;
  margin-left: 25px;
  width: 85%;
  z-index: 999999;
  position: fixed;
  width: calc(100% - 300px);
}

.hidden-contextmenu-option {
  display: none !important;
}

.screen-reader-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

@include tabletAndMore {
  .lexon-view-container {
    padding-top: $app-bar-height + 14px;
  }
}

@media (max-width: 960px) {
  .v-main:not(.remove-padding):not(.is-mobile) {
    padding-left: 53px !important;
  }
}
</style>
